import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ImageSource } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/AutomatedCatalogCarouselCard.types';

type Props = {
    alt: string;
    catalogId: number;
    imageSource: ImageSource;
    itemId: number;
    src: string;
};

const AutomatedCatalogCarouselCardItemImage = ({ alt, src }: Props) => {
    return (
        <div
            className={cn(
                // GENERAL
                'relative rounded-md bg-background-primary',
                // IMAGE HEIGHT CAPS (constants
                'h-[164px] w-[169px]',
                'smMax:h-[162px] smMax:max-h-[162px] smMax:w-1/3',
                'xsMax:h-[104px] xsMax:max-h-[104px] xsMax:w-1/3'
            )}
        >
            <img
                alt={alt}
                className="mx-auto flex h-full max-h-full w-full max-w-full rounded-md object-contain"
                src={src}
            />
        </div>
    );
};

export default AutomatedCatalogCarouselCardItemImage;
